export const DAYS_OF_MONTH = 30.4; // 30.4 days on average

export const FALLBACK_ESTIMATES = {
  IsLimitedEstimates: true,
  GlobalMinimumBudget: {
    DailyBudget: 2, MonthlyBudget: 40,
  },
  MinimumBudget: {
    DailyBudget: 2, MonthlyBudget: 40,
  },
  CompetitorBudgetLowerBound: {
    DailyBudget: 20,
  },
  SuggestedBudget: {
    DailyBudget: 10, MonthlyBudget: 200,
  },
  CompetitorBudgetUpperBound: {
    DailyBudget: 40,
  },
  MaximumBudget: {
    DailyBudget: 200, MonthlyBudget: 4000,
  },
  GlobalMaximumBudget: {
    DailyBudget: 500, MonthlyBudget: 10000,
  },
  Currency: 'USD',
};


export const currencyStrings = {
  ALL: _TL_('Albanian Lek (ALL)'),
  AED: _TL_('United Arab Emirates Dirham (AED)'),
  ARS: _TL_('Argentine Peso (ARS)'),
  AMD: _TL_('Armenian Dram (AMD)'),
  AUD: _TL_('Australian Dollar (AUD)'),
  AZN: _TL_('Azerbaijani Manat (AZN)'),
  BHD: _TL_('Bahraini Dinar (BHD)'),
  BDT: _TL_('Bangladeshi Taka (BDT)'),
  BZD: _TL_('Belize Dollar (BZD)'),
  BOB: _TL_('Bolivian Boliviano (BOB)'),
  BWP: _TL_('Botswanan Pula (BWP)'),
  BRL: _TL_('Brazilian Real (BRL)'),
  GBP: _TL_('UK Pound (GBP)'),
  BND: _TL_('Brunei Dollar (BND)'),
  BGN: _TL_('Bulgarian Lev (BGN)'),
  CAD: _TL_('Canadian Dollar (CAD)'),
  CHF: _TL_('Swiss Franc (CHF)'),
  CLP: _TL_('Chilean Peso (CLP)'),
  CNY: _TL_('Yuan Renminbi (CNY)'),
  COP: _TL_('Colombian Peso (COP)'),
  CRC: _TL_('Costa Rican Colón (CRC)'),
  CZK: _TL_('Czech Republic Koruna (CZK)'),
  DKK: _TL_('Danish Krone (DKK)'),
  DOP: _TL_('Dominican Peso (DOP)'),
  DZD: _TL_('Algerian Dinar (DZD)'),
  XCD: _TL_('East Caribbean Dollar (XCD)'),
  EGP: _TL_('Egyptian Pound (EGP)'),
  ETB: _TL_('Ethiopian Birr (ETB)'),
  EUR: _TL_('Euro (EUR)'),
  FJD: _TL_('Fijian Dollar (FJD)'),
  GEL: _TL_('Georgian Lari (GEL)'),
  GHS: _TL_('Ghanian Cedi (GHS)'),
  GTQ: _TL_('Guatemalan Quetzal (GTQ)'),
  HNL: _TL_('Honduran Lempira (HNL)'),
  HKD: _TL_('Hong Kong Dollar (HKD)'),
  HRK: _TL_('Croatian Kuna (HRK)'),
  HUF: _TL_('Hungarian Forint (HUF)'),
  ISK: _TL_('Icelandic Króna (ISK)'),
  INR: _TL_('Indian Rupee (INR)'),
  IDR: _TL_('Indonesian Rupiah (IDR)'),
  IQD: _TL_('Iraqi Dinar (IQD)'),
  ILS: _TL_('Israeli New Shekel (ILS)'),
  JMD: _TL_('Jamaican Dollar (JMD)'),
  JPY: _TL_('Japanese Yen (JPY)'),
  JOD: _TL_('Jordanian Dinar (JOD)'),
  KZT: _TL_('Kazakhstani Tenge (KZT)'),
  KES: _TL_('Kenyan Shilling (KES)'),
  KWD: _TL_('Kuwaiti Dinar (KWD)'),
  KGS: _TL_('Kyrgyzstani Som (KGS)'),
  KRW: _TL_('South Korea Won (KRW)'),
  LBP: _TL_('Lebanese Pound (LBP)'),
  LKR: _TL_('Sri Lankan Rupee (LKR)'),
  LYD: _TL_('Libyan Dinar (LYD)'),
  MOP: _TL_('Macanese Pataca (MOP)'),
  MKD: _TL_('Macedonian Denar (MKD)'),
  MWK: _TL_('Malawi Kwacha (MWK)'),
  MYR: _TL_('Malaysian Ringgit (MYR)'),
  MVR: _TL_('Maldivian Rufiyaa (MVR)'),
  MUR: _TL_('Mauritian Rupee (MUR)'),
  MXN: _TL_('Mexican Peso (MXN)'),
  MNT: _TL_('Mongolian Tugrik (MNT)'),
  MAD: _TL_('Moroccan Dirham (MAD)'),
  NZD: _TL_('New Zealand Dollar (NZD)'),
  NIO: _TL_('Nicaraguan Córdoba (NIO)'),
  NGN: _TL_('Nigerian Naira (NGN)'),
  NOK: _TL_('Norwegian Krone (NOK)'),
  OMR: _TL_('Omani Rial (OMR)'),
  PKR: _TL_('Pakistani Rupee (PKR)'),
  PAB: _TL_('Panamian Balboa (PAB)'),
  PYG: _TL_('Paraguayan Guarani (PYG)'),
  PEN: _TL_('Peruvian Nuevo Sol (PEN)'),
  PHP: _TL_('Philippine Peso (PHP)'),
  PLN: _TL_('Polish Zloty (PLN)'),
  QAR: _TL_('Qatari Riyal (QAR)'),
  RON: _TL_('Romanian Leu (RON)'),
  RSD: _TL_('Serbian Dinar (RSD)'),
  RUB: _TL_('Russian Ruble (RUB)'),
  RWF: _TL_('Rwandan Franc (RWF)'),
  SAR: _TL_('Saudi Riyal (SAR)'),
  SEK: _TL_('Swedish Krona (SEK)'),
  SGD: _TL_('Singapore Dollar (SGD)'),
  TZS: _TL_('Tanzanian Shilling (TZS)'),
  THB: _TL_('Thai Baht (THB)'),
  TOP: _TL_('Tongan Pa\'anga (TOP)'),
  TTD: _TL_('Trinidad and Tobago Dollar (TTD)'),
  TND: _TL_('Tunisian Dinar (TND)'),
  TRY: _TL_('Turkish Lira (TRY)'),
  TWD: _TL_('New Taiwan Dollar (TWD)'),
  UGX: _TL_('Ugandan Shilling (UGX)'),
  UAH: _TL_('Ukrainian Hryvnia (UAH)'),
  UYU: _TL_('Uruguayan Peso (UYU)'),
  USD: _TL_('US Dollar (USD)'),
  UZS: _TL_('Uzbekistani Som (UZS)'),
  VEF: _TL_('Venezuelan Bolivar (VEF)'),
  VES: _TL_('Sovereign Bolivar (VES)'),
  VND: _TL_('Dong (VND)'),
  XAF: _TL_('Central African CFA Franc (XAF)'),
  XOF: _TL_('West African CFA Franc (XOF)'),
  YER: _TL_('Yemeni Rial (YER)'),
  ZAR: _TL_('South African Rand (ZAR)'),
  ZMW: _TL_('Zambian Kwacha (ZMW)'),
};
